<template>
  <v-card>
    <v-card-title>確認</v-card-title>
    <v-card-text>
      <v-container>
        <v-row justify="center">
          <v-col md="12" align="center">
            <div
              v-if="this.type == 'important'"
              style="margin-left: 20px;display: table;font-size: 15px;font-weight: 900;color: red;height: 300px;"
            >
              <span style="display: table-cell;vertical-align: bottom;">
                {{ message }}
              </span>
            </div>
            <div
              v-else
              style="margin-left: 20px;font-size:15px;font-weight: 200;"
            >
              {{ message }}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="no()">No</v-btn>
      <v-btn color="green darken-1" text @click="yes()">Yes</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    message: String,
    tag: String,
    type: String, //type "important"
  },
  methods: {
    yes() {
      this.$emit("clickSubmit", true, this.tag);
    },
    no() {
      this.$emit("clickSubmit", false, this.tag);
    },
  },
};
</script>
